import { Progress } from "antd";
import react from "react";
import { Link } from "react-router-dom";
import downRedArrow from "../assets/icons/downRedArrow.png";
import upGreenArrow from "../assets/icons/upGreenArrow.png";
export const TEXT_CONSTANTS = {
  ADMIN_LOGIN_TEXT: "Admin Login",
  SUPPLIER_LOGIN_TEXT: "Supplier Login",
  SUSTAINABILITY_PROGRAM_TITLE: "Sustainability Program",
  SUSTAINABILITY_PORTAL_DESCRIPTION:
    "Welcome to Sustainability Portal, your destination for accessing sustainability reports",
  SUSTAINABILITY_LOGIN_TITLE: "Sustainability Login",
  SUSTAINABILITY_LOGIN_PROMPT:
    "Please select a method below to log into the Sustainability portal",
  DASHBOARD_TITLE: "Thank you for attending our carbon emission survey",
  DOWNLOAD_BUTTON: "Excel Download",
  KPI_SUMMARY: "Your KPI summary is displayed here",
  KPI_TRACKER: "KPI Tracker",
  HEADER_TEXT: "SUSTAINABILITY PROGRAM",
  DETAIL_VIEW_TITLE: "Detail View: ",
  PACKAGING_FORMAT_TITLE: "Format by %Recyclable weight",
  PACKAGING_MATERIAL_TITLE: "Material by %Recyclable weight",
  MARKET: "Market",
  SUPPLIER_NAME_PLACEHOLDER: "Enter Supplier Name",
  APPLY: "Apply",
  BUTTON_DETAILS: "Detail View",
  ADMIN_LOGIN_URL: "/adminLogin",
  SUPPLIER_LOGIN_URL: "/supplierLogin",
  pre_survey: "Pre-Survey",
  cdp_details: "CDP Details",
  REPORTING_YEAR: "CDP Reporting Year",
  SCORE: "CDP Score :",
  EMISSION_DATA: "Emission Data",
  ANNUAL_SAVINGS: "Annual Savings",
  COMMENTS: "Comments :",
  INTENSITY: "Intensity % attributed for your company :",
  DASHBOARD: "Dashboard",
  LOGBOOK_NEW_ENTRY:"New Entry",
  LOGBOOK_VIEW_ENTRY:"View Entry",
  SUPPLIER_SEARCH: "Supplier Search",
  REPORTING: "Reporting",
  GOALS: "Goals",
  CONTAINER_HEADER: "Details of Waste Materials Used:",
  MATERIAL: "Material",
  SOURCE_REDUCED: "Source Reduced",
  RECYCLED: "Recycled",
  LAND_FILLED: "Landfilled",
  COMBUSTED: "Combusted",
  TOTAL_EMISSIONS: "Total Emissions",
  DASHBOARD_LINK: "Dashboard",
  SUPPLIER_SEARCH_LINK: "Supplier Search",
  SIGN_IN_TITLE: "Sign up or Sign in",
  ADMIN_LOGIN_BUTTON: "Log In",
  SUPPLIER_LOGIN_BUTTON: "Log In",
  ERROR_UNKNOWN: "Unknown Error",
  INVALID_CRED: "Please check your credentials or sign up to continue.",
  USERNOT_FOUND: "User not found",
  ERROR_ADMIN_NOT_REGISTERED: "Admin Not Registered",
  ERROR_ADMIN_NOT_REGISTERED_CONTENT:
    "The admin account is not registered. Please contact support or try another account.",
  ERROR_SESSION_TIMEOUT: "Your session has expired. Please log in again.",
  ERROR_FETCH_USER_INFO: "Failed to fetch user information. Please try again.",
  ERROR_LOGIN_FAILED: "Login failed. Please try again.",
  NETWORK_ERROR: "Network response was not ok",
  WELCOME_MESSAGE:
    "Welcome to Sustainability Portal, your destination for accessing sustainability reports",
  IMAGE_ALT_TEXT: "Illustration of a person working on a computer",
  PDF_DOWNLOAD: "Download PDF",

  // New constants for messages
  FILL_REQUIRED_FIELDS: "Please fill in all required fields before saving.",
  FILL_REQUIRED_FIELDS_NEXT:
    "Please fill in all required fields before proceeding to the next pillar.",
  FILL_REQUIRED_FIELDS_SWITCH:
    "Please fill in all required fields before switching pillars.",
  PILLAR_NOT_FOUND: "Pillar not found.",
  SAVE_FAILED: "Failed to save data.",
  RESET_FAILED: "Failed to reset data.",

  // Error messages
  ERROR_FETCHING_QUESTIONS: "Error fetching questions:",
  ERROR_FETCHING_ANSWERS: "Error fetching answers:",
  ERROR_SAVING_DATA: "Error saving/updating data:",
  ERROR_RESETTING_GOALS: "Error resetting goals:",

  // Success messages with formatting
  SAVE_SUCCESS: "{0} Data saved successfully!",
  RESET_SUCCESS: "{0} Data reset successfully!",
  // Added constants for GetStartedPage
  GET_STARTED_HEADING:
    "Analyze Your Sustainability Reports With Sustainability Platform",
  GET_STARTED_DESCRIPTION:
    "Get insights into your sustainability performance, track your goals, and generate comprehensive reports. Our platform makes sustainability reporting easy and accessible for your organization.",
  GET_STARTED_BUTTON_TEXT: "Get Started",
  PDF_DOWNLOAD: "PDF Download",
  NEXT: "Next",
  SAVE: "Save",
  RESET: "Reset",
  ADD: "Add",
  DELETE: "Delete",
  BUSINESS_UNIT: "Business Unit",
  CALCULATION_WARNING:
    "No calculatedValue found in the response for this comibation",
  REPORT_SAVE_VALIDATION_ERRORMSG: "No Questions were answered to Save.",
  REPORT_SAVE_VALIDATION_NODATA:
    "No data available to save. Please answer at least one question.",
  ERROR: "Error",
  SUCCESS: "SUCCESS",
  EMISSIONS_SAVED: "Emission Saved",
  METRIC_TON: "MT",
  SUSTAINABILITY_APP_LINK: "Sustainability",
  WATCH_TOWER_APP_LINK: "Watch Tower",
  LOGBOOK: "Logbook",
  WATCH_TOWER_INFO_TEXT: `Please click on the below button to Navigate to "Watch Tower" App`,
  SUSTAINABILITY_INFO_TEXT: `Please click on the below button to Navigate to "Sustainability" App`,
  LOGBOOK_INFO_TEXT: `Please click on the below button to Navigate to "LogBook" App`,
  DASHBOARD_TITLE: "Thank you for attending our carbon emission survey",
  WARNING: "Please enter userID and emailID",
  USERID_WARNING: "Please enter userID",
  EMAIL_WARNING: "Please enter emailID",
  TOTAL_WEIGHT: "Total Weight",
  RECYCLE_WEIGHT: "Recyclable Weight",
  PERCENT_RECYCLABLE: "%Recyclable",
  CARBON_EMISSION_LINECHART_TITLE:'YOY Changes',
  TOTAL_EMISSION:"Total Emission",
  EMISSION_AVOIDED:"Emission Avoided",
  PERCENTAGE_REDUCTION:"Percentage Reduction",
  SUPPLIER_ENGAGEMENT:"Supplier Engagement",
  EPM_INFO_TEXT: `Please click on the below button to Navigate to "Employee Process Management" App`,
  EPM_APP_LINK: "EPM"
};

export const RESTRICTED_SYMBOLS = ["e", "E", "-", "+"];

export const LINKS = {
  DASHBOARD: "Dashboard",
  SUPPLIER_SEARCH: "Supplier Search",
};

export const DASH_CARDS = {
  CARBON_EMISSION_AVOIDED: {
    TITLE: "Carbon Emission Avoided",
    FIELDS: [
      { label: "Emission Avoided", value: "0 MTCO2" },
      { label: "LY Emission Avoided", value: "0 MTCO2" },
      { label: "% Changed", value: "0%" },
    ],
  },
  RECYCLE_PACKAGING: {
    TITLE: "Recycle Packaging",
    FIELDS: [
      { label: "Recyclable Packaging", value: "0 MT" },
      { label: "LY Recyclable Avoided", value: "0 MT" },
      { label: "% Changed", value: "0%" },
    ],
  },
  CARBON_REPORTED: {
    TITLE: "CDP Carbon Emission Reported",
    FIELDS: [
      { label: "Emission ", value: "0 MTCO2" },
      { label: "LY Emission", value: "0 MTCO2" },
      { label: "% Changed", value: "0%" },
    ],
  },
  SUPPLIERS_SUBMITTED_GOALS: {
    TITLE: "Suppliers Submitted Goals",
    FIELDS: [
      { label: "TY Supplier Count", value: "0" },
      { label: "LY Supplier Count", value: "0" },
      { label: "YOY", value: "0" },
    ],
  },
};
export const PRODUCT_CONSTANTS = {
  PRODUCT_CATEGORIES: {
    HARDLINES: "Hardlines",
    ELECTRONICS: "Electronics",
    APPAREL: "Apparel",
    AUTOMOTIVE: "Automotive",
  },
  PRODUCT_CATEGORIES_DATA: [
    { key: "1", name: "Hardlines" },
    { key: "2", name: "Electronics" },
    { key: "3", name: "Apparel" },
    { key: "4", name: "Automotive" },
  ],
};
export const COUNTRIES = {
  US: "US",
  IN: "IN",
};
export const SUPPLIER_SEARCH_EXCEL_COLUMNS = [
  "Company Name",
  "Supplier ID",
  "Total Carbon Emission",
  "Emission Avoided",
  "Recycle Packaging (%)",
  "Active Goals Count",
];
export const SUPPLIER_SEARCH_COLUMNS = [
  {
    title: "Company Name",
    dataIndex: "companyName",
    key: "companyName",
    render: (companyName) => (
      <Link to={`profile/${companyName}`}>{companyName}</Link>
    ),
  },
  { title: "Supplier ID", dataIndex: "supplierId", key: "supplierId" },
  {
    title: "Total Carbon Emission",
    dataIndex: "totalEmissions",
    key: "totalEmissions",
  },
  {
    title: "Emission Avoided",
    dataIndex: "emissionSaved",
    key: "emissionSaved",
  },
  {
    title: "Recycle Packaging (%)",
    dataIndex: "recyclePackaging",
    key: "recyclePackaging",
  },
  {
    title: "Active Goals Count",
    dataIndex: "activeGoalsCount",
    key: "activeGoalsCount",
  },
];
export const BASE_URL = "http://localhost:8080";
export const SUPPLIER_SEARCH_FILTER = "suppliers/filter/data";
export const CDP_DETAILS_API = "supplier/reporting/cdpdetails";
export const SAVE_CDP_DETAILS_API = "supplier/reporting/savecdp";
const currentYear = new Date().getFullYear();
export const MIN_VALUE = 1;
export const PERCENT_MAX_VALUE = 100;
const MAX_VALUE = 1000000;

export const validationMessages = {
  cdprequired: "* CDP Reporting year is required",
  scorerequired: "* CDP Score is required",
  scope1: "* Scope 1 is required",
  scope2Location: "* Scope 2 Location Based is required",
  scope2Market: "* Scope 2 Market Based is required",
  annualSavingintiative: "* Initiative Category is required",
  annualCo2: "* Annual CO2 Savings is required",
  annualLifetime: "* Lifetime of Initiative is required",
  intensity: "* Intensity % is required",
  cdpValidYear: "* Reporting year must be a valid 4-digit year",
  cdpValid: `* Reporting year should be between ${
    currentYear - 2
  }  and ${currentYear}`,
  cdpscore: "* CDP score must be either A, B, C or A-, B-, C-",
  comments: "* Comments should not be more than 10 words",
  intensityNumber: "* Intensity % must be a number",
  intensityBetween: "* Intensity % must be between 0 and 100",
  invalidDoubleFormat: "* Please enter a valid number in double format.",
  intiativeLength: "* should not exceed 100 characters.",
  intiativeWords: "* should not exceed more than 10 words.",
  intiativeYear: `* cannot be negative year or zero.`,
  yearLimit: `* cannot exceed 10 years.`,
  commentsLimit: "* Comments should not exceed 200 characters.",
  co2SavingRange: `* annualCo2Savings must be between ${MIN_VALUE} and ${MAX_VALUE}.`,
  scope1Range: `* Scope 1 must be between ${MIN_VALUE} and ${MAX_VALUE}.`,
  scope2Range: `* Scope 2 Location Based must be between ${MIN_VALUE} and ${MAX_VALUE}.`,
  marketbasedRange: `* Scope 2 Market Based must be between ${MIN_VALUE} and ${MAX_VALUE}.`,
};

export const AlertMessages = {
  NEXT_CONFIRMATION: "Are you sure you want to move to the next page?",
  SAVED: "Fields Saved",
  SAVE_REQUIRED: "Save Required",
  SAVE_CHANGES: "Please save your changes before proceeding.",
  SAVE_SUCESS: "Your changes have been saved successfully.",
  RESET_CONFIRMATION: "Are you sure you want to Reset the values in this page?",
  SAVE_CONFIRMATION: "Do you want to save the values entered?",
  MISSING_FIELDS: "Please fill in all fields.",
  CALCULATION_INCOMPLETE:
    "Please ensure all calculations are completed before saving.",
  SELECT_OPTION: "Select an option",
  ACTIONS: "Action",
  NUMBER_ERROR: "Value must be a positive number",
  WARNING_ADD_QUESTION:
    "Please calculate all previous questions before adding a new one",
  SUPPLIERID_DUPLICATE:
    "This supplier ID already exists. Please provide a unique supplier ID.",
  LOG_OUT: "Are you sure you want to log out?",
};

export const QUESTION_TYPES = {
  question: "QUESTION",
  table: "TABLE",
};

export const SWITCH_STATE_DEFAULT = false;
export const QUESTION_BORDER_STYLE =
  "border-[1px] border-dashed border-[#1F405A] rounded-[10px]";

export const BUTTON_CLASSES = {
  calculate: "bg-[#1F405A] text-white",
  addButtonDisabled: "opacity-50 cursor-not-allowed",
  emissionSavedInput: "w-[75px] bg-[#EAF5FF] ml-[4px]",
};

export const DROPDOWN_ITEMS = [
  { label: "Material Option 1", key: "1" },
  { label: "Material Option 2", key: "2" },
  { label: "Material Option 3", key: "3" },
];
export const INPUT_FIELDS = [
  "sourceReduced",
  "recycled",
  "landfilled",
  "combusted",
  "totalEmissions",
];

export const BUTTON_TEXT = {
  ADD: "Add",
  DELETE: "Delete",
  DETAILS: "Detail view",
  RESET: "Reset",
  SAVE: "Save",
  NEXT: "Next",
  PDF_DOWNLOAD: "PDF DOWNLOAD",
};

export const SWITCH_TEXT = {
  YES: "Yes",
  NO: "No",
};

export const PLACEHOLDER_TEXT = {
  SELECT_MATERIAL: "Select Material",
  REPORTING_YEAR: "Enter Reporting Year",
  CDP_SCORE: "Enter CDP Score",
  SCOPE1: "Enter Scope 1",
  SCOPE2_LOCATION: "Enter Scope 2 Location Based",
  SCOPE2_MARKET: "Enter Scope 2 Market Based",
  INITIATIVE_CATEGORY: "Enter Initiative Category",
  CO2_SAVINGS: "Enter CO2 Savings",
  LIFETIME: "Select Lifetime of Initiative",
  COMMENTS: "Enter Comments",
  INTENSITY: "Enter Intensity %",
};

export const LIFETIMEOF_INITIATIVE_OPTIONS = [
  "<1 year",
  "1-2 years",
  "3-5 years",
  "6-10 years",
  "11-15 years",
  "16-20 years",
  "21-30 years",
  ">30 years",
];
export const LABEL_TEXT = {
  SCOPE1: "Scope 1 Location Based",
  SCOPE2_LOCATION: "Scope 2 Location Based",
  SCOPE2_MARKET: "Scope 2 Market Based",
  INITIATIVE_CATEGORY: "Initiative Category",
  CO2_SAVINGS: "CO2 Savings",
  LIFETIME_INITIATIVE: "Lifetime of Initiative",
};

export const DASHBOARD_CONSTANTS = {
  CARBON_EMISSION: {
    title: "Carbon Emission Reported CDP",
    fields: [
      { label: "Emission Avoided", value: "80%" },
      { label: "LY Emission Avoided", value: "70%" },
      { label: "% Changed", value: "14%" },
    ],
  },
  RECYCLE_PACKAGING: {
    title: "Recycle Packaging",
    fields: [
      { label: "Recyclable Packaging", value: "80%" },
      { label: "LY Recyclable Packaging", value: "70%" },
      { label: "% Changed", value: "14%" },
    ],
  },
  CARBON_REPORTED: {
    title: "Carbon Reported",
    fields: [
      { label: "Emission", value: "80%" },
      { label: "LY Emission", value: "60%" },
      { label: "% Changed", value: "33%" },
    ],
  },
};
export const WASTE_HEADERS = [
  TEXT_CONSTANTS.MATERIAL,
  TEXT_CONSTANTS.SOURCE_REDUCED,
  TEXT_CONSTANTS.RECYCLED,
  TEXT_CONSTANTS.LAND_FILLED,
  TEXT_CONSTANTS.COMBUSTED,
  TEXT_CONSTANTS.TOTAL_EMISSIONS,
];
export const NOTIFICATION_MESSAGES = {
  resetSuccessful: {
    message: "Reset Successful",
    description: "Data has been reset successfully.",
  },
  saveSuccessful: {
    message: "Save Successful",
    description: "Data has been saved successfully.",
  },
  saveFailed: {
    message: "Save Failed",
    description: (error) => `Error saving data: ${error.message}`,
  },
  resetFailed: {
    message: "Reset Failed",
    description: (error) => `Error resetting data: ${error.message}`,
  },
  endOfTabs: {
    message: "End of Tabs",
    description: "You are already on the last tab.",
  },
  // MISSING_FIELDS_TITLE: "Missing Required Fields",
  CALCULATION_INCOMPLETE_TITLE: "Calculations Not Completed",
  SAVE_SUCCESS_TITLE: "Fields Saved",
  SAVE_SUCCESS_DESC: "Your changes have been saved successfully.",
  SAVE_FAILURE_TITLE: "Save Failed",
  SAVE_FAILURE_DESC: "Data is not saved. Please try again",
  ERROR_FILL_FIELDS: "Please fill in all required fields",
  ERROR_NO_CALCULATED_VALUE: "No calculatedValue found in the response",
  ERROR_CALCULATION_FAILED: "Failed to calculate. Please try again.",
  SUCCESS_CALCULATION: "Calculation completed successfully",
};
export const tabListNoTitle = [
  { key: "preSurvey", tab: "Pre-Survey" },
  { key: "cdpDetails", tab: "CDP Details" },
  { key: "reporting", tab: "Reporting" },
];
export const reportingNestedTabs = [
  { key: "energy", tab: "Energy" },
  { key: "waste", tab: "Waste" },
  { key: "packaging", tab: "Packaging" },
];
export const CONFIRMATION_MESSAGES = {
  SAVE: "Are you sure you want to save? Once saved, you will not be able to undo the changes.",
  TABCHANGE: "Do you want to save changes before tab change?",
};
export const API_URLS = {
  GOOGLE_USER_INFO: "https://www.googleapis.com/oauth2/v3/userinfo",
  LOGIN_URL: "/auth/signup",
};

export const ROUTE_CONSTANTS = {
  ADMIN_DASHBOARD: "/admindashboard",
  SUPPLIER_SEARCH: "/reporting",
  SUPPLIER_DASHBOARD: "/supplierdashboard",
  LOGIN: "/login",
  SIGNUP: "/signup",
  GOALS: "/goals",
};

export const IMAGE_PATHS = {
  LOGIN_IMAGE: "/assets/loginImage.jpg",
};

export const SESSION_TIMEOUT = 60 * 1000;
export const TEXTS = {
  COMPANY_NAME: "Company Name",
  SUPPLIER_ID: "Supplier ID",
  SIDEBAR_DASHBOARD: "Dashboard",
  SIDEBAR_SUPPLIER_SEARCH: "Supplier Search",
  SUPPLIER_TYPE: "Supplier Type",
  COUNTRY_CODE: "Country Code",
  APPLY_FILTER: "Apply Filter",
  ERROR_MESSAGE: "Please enter all details",
  SUCCESS_MESSAGE: "Filter applied successfully",
  SUSTAINABILITY_PROGRAM: "SUSTAINABILITY PROGRAM",
  DESIGNATION: "Designation",
  ENTER_DESIGNATION: "Enter your Designation",
  ENTER_USERTYPE: "Enter User Type",

  SUPPLIER_DETAILS_TITLE: "Supplier Details",
  ADDRESSLINE1: "Address Line 1",
  ADDRESSLINE2: "Address Line 2",
  COUNTRY: "Country",
  STATE: "State",
  ZIPCODE: "Zipcode",
  CONTACTDETAILSTITLE: "Contact Details",
  FIRSTNAME: "First Name",
  LASTNAME: "Last Name",
  EMAILID: "Email ID",
  PHONENUMBER: "Phone Number",
  USERTYPE: "User Type",
  SUPPLIERTYPE: "Supplier Type",
  ADDCONTACT: "Add Contact",
  REMOVECONTACT: "Remove Contact",
  ADDSUPPLIERID: "Add Supplier ID",
  REMOVESUPPLIERID: "Remove Supplier ID",
  SUBMITBUTTON: "Submit",
  CONFIRMSUBMISSION: "Confirm Submission",
  CONFIRMCONTENT: "Are you sure you want to submit the supplier data?",
  ISREQUIRED: " is required",
  USERID: "User Id",
};

export const SUPPLIER_TYPE_OPTIONS = ["Type 1", "Type 2"];
export const COUNTRY_CODE_OPTIONS = ["US", "UK", "IN"];

export const API_BASE_URL = "https://techsolutionsservice.ustdev.com"; // Assuming this is your backend URL

export const ROUTES = {
  FETCH_SUPPLIER: `${API_BASE_URL}/sustainability`, // Base URL for supplier-related endpoints
  FETCH_SUPPLIER_GOALS: `${API_BASE_URL}/sustainability/mapped-supplier-goals`, // Goals URL
  GENERATE_PDF: `${API_BASE_URL}/goals/mapped-supplier-goals`, // Same endpoint for PDF data
};

export const MESSAGES = {
  PDF_GENERATION_SUCCESS: "PDF generated and downloaded successfully!",
  PDF_GENERATION_FAILED: "No Goals data to Download.",
  SAVE_SUCCESS: "Goals saved successfully.",
  UNSAVED_CHANGES_TITLE: "Unsaved Changes",
  UNSAVED_CHANGES_CONTENT:
    "You have unsaved changes. Are you sure you want to switch tabs?",
  DOWNLOAD_PDF: "PDF Download",
};
export const SUPPLIER_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

export const SUPPLIERS_URL = `${API_BASE_URL}/suppliers`;

export const API_ENDPOINTS = {
  GOALS: "/api/goal-config/goals",
  SUPPLIER: "/sustainability",
  SAVE_ENERGY: "/energy/save",
  SAVE_WASTE: "/waste/save",
  SAVE_PACKAGING: "/packaging/save",
  CALCULATE: "/lookup/calculate",
  SAVE_REPORTS_BY_SUPPLIER: "/reportsBySupplier/saveorupdate",
};

export const PDF_TYPES = {
  BUSINESS: "business",
};

export const PDF_COLORS = {
  HEADER_BACKGROUND: [0, 60, 81],
  HEADER_TEXT: [255, 255, 255],
  SUPPLIER_NAME: [35, 31, 32],
  PILLAR_NAME: [0, 110, 116],
  GOAL_HEADER: [0, 60, 81],
  GOAL_HEADER_BACKGROUND: [240, 240, 240],
  BODY_TEXT: [0, 0, 0],
  FOOTER_TEXT: [150, 150, 150],
};

export const PDF_FONTS = {
  HEADER: 20,
  SUPPLIER_NAME: 16,
  PILLAR_NAME: 14,
  GOAL_HEADER: 12,
  BODY: 10,
  FOOTER: 10,
};

export const StatusMessages = {
  IN_PROGRESS: "In Progress",
  SUBMITTED: "Submitted",
};

export const CONSTANTS = {
  HEADER_TEXT: "Sustainability",
  DASHBOARD: "Dashboard",
  REPORTING: "Reporting",
  GOALS: "Goals",
  PDF_DOWNLOAD: "PDF Download",
};
export const ERROR_MESSAGES = {
  companyNameRequired: "Company Name is required",
  characterMax: "Value should not exceed 100 characters",
  characterMin: "Value should atleast have 2 characters",
  addressLine1Required: "Address Line 1 is required",
  addressLine1Max: "Address Line 1 cannot exceed 100 characters",
  addressLine2Max: "Address Line 2 cannot exceed 100 characters",
  countryRequired: "Country is required",
  stateRequired: "State is required",
  zipcodeRequired: "Zipcode is required",
  zipcodePattern: "Zipcode must be 5 or 6 digits",
  contactEmpty: "Please fill all required fields before adding a new contact.",
  supplierIdEmpty:
    "Please fill all required fields before adding a new supplier ID.",
  defaultContactCannotRemove: "Default contact cannot be removed.",
  defaultSupplierCannotRemove: "Default supplier ID cannot be removed.",
  submissionCancelled: "Submission cancelled",
  formSubmissionSuccess: "Successfully signed up. Please Login.",
  formSubmissionError: (error) => `Error: ${error}`,
  supplierIdRequired: "Supplier ID is required",
  supplierIdMaxLength: "Supplier ID cannot exceed 6 characters",
  countryCodeRequired: "Country Code is required",
  duplicateSupplierId: "duplicate supplier IDs not allowed",
  emailRequired: "Email id is Required",
  userTypeRequired: "Please select your User Type",
  userIdRequired: "Please Enter your User ID",
  userIdmax: "Please enter less than 10 characters",
};

export const VALIDATION_RULES = {
  required: { required: true, message: ERROR_MESSAGES.companyNameRequired },
  firstNameRequired: {
    required: true,
    message: TEXTS.FIRSTNAME + TEXTS.ISREQUIRED,
  },
  lastNameRequired: {
    required: true,
    message: TEXTS.LASTNAME + TEXTS.ISREQUIRED,
  },
  phoneNumberRequired: {
    required: true,
    message: TEXTS.PHONENUMBER + TEXTS.ISREQUIRED,
  },
  userTypeRequired: {
    required: true,
    message: TEXTS.USERTYPE + TEXTS.ISREQUIRED,
  },
  supplierTypeRequired: {
    required: true,
    message: TEXTS.SUPPLIERTYPE + TEXTS.ISREQUIRED,
  },
  emailRequired: {
    required: true,
    message: TEXTS.EMAILID + TEXTS.ISREQUIRED,
  },
  max100: { max: 100, message: ERROR_MESSAGES.characterMax },
  min2: { min: 2, message: ERROR_MESSAGES.characterMin },
  zipcodePattern: {
    pattern: /^[0-9]{5,6}$/,
    message: ERROR_MESSAGES.zipcodePattern,
  },
  email: { type: "email", message: "Please enter a valid email address" },
  onlyLetters: {
    pattern: /^[a-zA-Z\s]+$/,
    message: "This field should only contain letters",
  },

  supplierIdRequired: {
    required: true,
    message: ERROR_MESSAGES.supplierIdRequired,
  },
  supplierIdMaxLength: { max: 6, message: ERROR_MESSAGES.supplierIdMaxLength },
  countryCodeRequired: {
    required: true,
    message: ERROR_MESSAGES.countryCodeRequired,
  },
  userIdRequired: { required: true, message: ERROR_MESSAGES.userIdRequired },
  userIdmax10: { max: 10, message: ERROR_MESSAGES.userIdmax },
};

export const PHONE_VALIDATION = {
  pattern: /^\d{10,10}$/,
  message: "Phone Number must be 10 digits",
};

export const InputTypes = {
  NUMBER: "number",
  TEXT: "text",
  DROPDOWN: "dropdown",
};
export const DATA_PACKAGING_FORMAT = [
  { name: "Bottle/Jug", value: 80 },
  { name: "Home: Bath & Shower", value: 20 },
];

export const DATA_PACKAGING_MATERIAL = [
  { name: "PET", value: 40 },
  { name: "PP", value: 30 },
  { name: "Other Plastic", value: 20 },
  { name: "Paper", value: 10 },
];
export const DATA_CARBON_EMISSION_LEGEND = [
  { name: "Energy", value: 40 },
  { name: "Packaging", value: 30 },
  { name: "Waste", value: 20 }
];
export const MATERIAL_COLORS = [
  "#277A30", "#0A3DC0", "#FDE384", "#BD4545",
  "#FF7F50", "#6A5ACD", "#20B2AA", "#FF69B4",
  "#FFD700", "#00FA9A", "#FF6347", "#40E0D0",
  "#8A2BE2", "#FF4500", "#3CB371", "#DAA520",
  "#1E90FF", "#B22222", "#ADFF2F"
];

export const FORMAT_COLORS = [
  "#90DBF4", "#98F5E1",
  "#FFA07A", "#7B68EE", "#48D1CC", "#C71585",
  "#FFFACD", "#00CED1", "#CD5C5C", "#7FFFD4",
  "#9370DB", "#DC143C", "#66CDAA", "#F4A460",
  "#87CEFA", "#A52A2A", "#7CFC00"
];

export const YOY_COLORS = ["#277A30", "#144FA8","#F4783F"];

export const STATISTIC = [
  { title: TEXT_CONSTANTS.TOTAL_WEIGHT, value: "118 MT" },
  { title: TEXT_CONSTANTS.RECYCLE_WEIGHT, value: "12 MT" },
  { title: TEXT_CONSTANTS.PERCENT_RECYCLABLE, value: "10.16%" },
  { title: TEXT_CONSTANTS.EMISSIONS_SAVED, value: "1.5 MTCO2" } 
];

export const TABLE_COLUMNS = [
  {
    title: "Packaging Use",
    dataIndex: "packagingUse",
    key: "packagingUse",
    align: "left",
  },
  {
    title: "Packaging Format",
    dataIndex: "packagingFormat",
    key: "packagingFormat",
    align: "left",
  },
  {
    title: "Packaging Material",
    dataIndex: "packagingMaterial",
    key: "packagingMaterial",
    align: "center",
  },
  {
    title: "Total Weight",
    dataIndex: "totalWeight",
    key: "totalWeight",
    align: "center",
  },
  {
    title: "Recyclable Weight",
    dataIndex: "recyclableWeight",
    key: "recyclableWeight",
    align: "center",
  },
  {
    title: "% Recyclability",
    dataIndex: "recyclabilityPercentage",
    key: "recyclabilityPercentage",
    align: "center",
  },
  // {
  //   title: "% YOY",
  //   dataIndex: "yoyPercentage",
  //   key: "yoyPercentage",
  //   align: "center",
  //   render: (YOY) =>
  //     YOY > 10 ? (
  //       <div className="flex flex-row items-center justify-center">
  //         {YOY}
  //         <img src={upGreenArrow} alt="icon" className="w-2 h-2 ml-2" />
  //       </div>
  //     ) : (
  //       <div className="flex flex-row items-center justify-center">
  //         {YOY}
  //         <img src={downRedArrow} alt="icon" className="w-2 h-2 ml-2" />
  //       </div>
  //     ),
  // },
];

export const TABLE_DATA = [
  {
    key: "1",
    supplier: "Company 1",
    packagingUse: "Liquid Drinks",
    packagingFormat: "Bottle/Jug",
    packagingMaterial: "PET",
    totalWeight: 22,
    recyclableWeight: 3,
    recyclabilityPercentage: 13.63636,
    YOY: 1,
  },
  {
    key: "2",
    supplier: "Company 2",
    packagingUse: "Liquid Drinks",
    packagingFormat: "Bottle/Jug",
    packagingMaterial: "PP",
    totalWeight: 40,
    recyclableWeight: 2,
    recyclabilityPercentage: 5,
    YOY: 12,
  },
  {
    key: "3",
    supplier: "Company 3",
    packagingUse: "Toys",
    packagingFormat: "Home: Bath & Shower",
    packagingMaterial: "Other Plastic",
    totalWeight: 36,
    recyclableWeight: 1,
    recyclabilityPercentage: 2.777778,
    YOY: 10,
  },
  {
    key: "4",
    supplier: "Company 4",
    packagingUse: "Toys",
    packagingFormat: "Home: Bath & Shower",
    packagingMaterial: "Paper",
    totalWeight: 20,
    recyclableWeight: 6,
    recyclabilityPercentage: 30,
    YOY: 18,
  },
];

export const SUPPLIER_DETAILS_CONSTANTS = {
  SUPPLIER_DETAILS: "Supplier Details",
  CONTACT_DETAILS: "Contact Details",
  ADDITIONAL_DETAILS: "Additional Details",
  SUPPLIER_TYPE: "supplier",
  CONTACT_TYPE: "contact",
  ADDITIONAL_TYPE: "additional",
  BUTTON_NEXT: "Next",
  BUTTON_PREVIOUS: "Back",
  BUTTON_SUBMIT: "Submit",
  BUTTON_ADD: "Add",
  BUTTON_CANCEL: "Clear",
  SUPPLIER_ID: "Supplier ID",
  COUNTRY_CODE: "Country Code",
  SELECT_COUNTRY: "Select Country Code",
  OPTION_ADMIN: "Supplier Admin",
  OPTION_USER: "Supplier User",
  CONTACTINFO_ERROR: "Please add at least one contact detail.",
  ADDITIONALINFO_ERROR: "Please add at least one supplier ID.",
  PROMISE_ERROR: "Phone Number must be numeric",
  DESIGNATION_RULE: "Please input your designation!",
  USERTYPE_RULE: "Please select your User Type!",
};

export const selectStyleReport = {
  width: "155px",
  borderBottom: "1px dashed #014D4E",
  marginTop: "10px",
};
export const selectStyleGoals = {
  width: "155px",
  backgroundColor: "#E6F4F1",
  borderBottom: "1px dashed #014D4E",
  marginBottom: "2px",
};

//CDP Designation options

export const DESIGNATION_OPTIONS = [
  { key: "TechLead", value: "TechLead", label: "Technical Lead" },
  {
    key: "SoftwareArchitect",
    value: "SoftwareArchitect",
    label: "Software Architect",
  },
  {
    key: "SeniorDeveloper",
    value: "SeniorDeveloper",
    label: "Senior Software Developer",
  },
  { key: "Developer", value: "Developer", label: "Software Developer" },
  {
    key: "QAEngineer",
    value: "QAEngineer",
    label: "Quality Assurance Engineer",
  },
  { key: "SystemAdmin", value: "SystemAdmin", label: "System Administrator" },
  { key: "ITSupport", value: "ITSupport", label: "IT Support Specialist" },
  { key: "Intern", value: "Intern", label: "Intern" },
  { key: "Others", value: "Others", label: "Others" },
];

export const SupplierIdtooltipContent =
  "Supplier ID must be 6 digits and should not contain alphabets. Use the first 6 digits if it's longer.";

export const ProfilePageText = {
  COMPANY_DETAILS: 'Company Details',
  ASSOCIATED_SUPPLIERS: 'Associated Suppliers',
  CONTACT_DETAILS: 'Contact Details',
  ACCESS_DENIED: 'Access Denied',
  SOMETHING_WRONG: 'Something went wrong',
  UNABLE_TO_LOAD_PROFILE:'Unable to load profile',
  NOT_AUTHORIZED: 'Not authorized',
  NO_PERMISSION:'You dont have permission to view this profile.',
  UNABLE_TO_LOAD: 'Unable to load the data at the moment.',
  COMPANY: 'Company',
  ADDRESS_LINE_1: 'Address Line 1',
  ADDRESS_LINE_2: 'Address Line 2',
  SUPPLIER_TYPE:'Supplier Type',
  STATE: 'State',
  COUNTRY: 'Country',
  ZIPCODE: 'Zipcode',
  SUPPLIER_ID: 'Supplier ID:',
  COUNTRY_LABEL: 'Country:',
  COUNTRY_CODE:'Country Code',
  EMAIL: 'Email',
  ROLE: 'Role',
  NAME: 'Name',
  DESIGNATION: 'Designation',
  PHONE: 'Phone',
  GO_BACK: 'Go Back',
  NOT_AVAILABLE: 'N/A',
  PROFILEENDPOINT: 'signup/admin/profile',
  ROLE: 'Role',
}

export const DeleteUserText = {
  TITLE: "DELETE USERS",
  CONFIRM_DELETE: "Confirm Delete",
  SEARCH_PLACE_HOLDER: "Search users by ID, email, or role...",
  CLEAR_SELECTED: "Clear Selected",
  DELETE: "Delete",
  YES: "Yes",
  NO: "No",
  USER_ID: "User ID",
  EMAIL: "Email",
  ROLE: "Role",
  SELECT_USERS_DELETE: "Please select users to delete",
  DELETE_SUCESS: " user(s) deleted successfully",
  DELETE_FAILURE: "Failed to delete users",
  FAILED_TO_LOAD: "Failed to load user data",
  CANNOT_SELF_SELECT: "One Supplier Admin is mandatory",
  CONFIRM_DELETE: "Are you sure you want to delete the selected ",
  GET_COMPANY_USERS: "/signup/company/allUsers/",
  DELETE_COMPANY_USERS: "/signup/company/deleteUsers"
};
export const CARBON_EMIISION_STATISTICS = [
  { title: TEXT_CONSTANTS.TOTAL_EMISSION, value: "6500 MT" },
  { title: TEXT_CONSTANTS.EMISSION_AVOIDED, value: "500 MT" },
  { title: TEXT_CONSTANTS.PERCENTAGE_REDUCTION, value: "7.69 %" },
  { title: TEXT_CONSTANTS.SUPPLIER_ENGAGEMENT, value: "80 MTCO2" },
];
export const carbonEmissiondata = [
  {
    name: "Year 1",
    energy: 4,
    packaging: 2,
    waste: 6,
  },
  {
    name: "Year 2",
    energy: 2,
    packaging: 10,
    waste: 3,
  },
  {
    name: "Year 3",
    energy: 5,
    packaging: 4,
    waste: 3,
  },
  
];

// Supplier Goals Statistics
export const supplierGoalstatics = [
  { title: "Total no. of suppliers", value: "65" },
  { title: "Goal count active", value: "80" },
  { title: "Supplier Achieved percentage", value: "7.69%" },
]
export const energyconsumptiondata = [
  { name: "Used", value: 65, color: "#277A30" },
  { name: "Remaining", value: 35, color: "#144FA8" },
]

export const wastereductiondata = [
  { name: "Used", value: 40, color: "#277A30" },
  { name: "Remaining", value: 60, color: "#144FA8" },
]

export const ghgreductiondata = [
  { name: "Used", value: 85, color: "#277A30" },
  { name: "Remaining", value: 15, color: "#144FA8" },
]

export const suppliersyoydata = [
  {
    name: "Energy",
    2024: 45,
    2025: 25,
  },
  {
    name: "Waste",
    2024: 55,
    2025: 30,
  },
  {
    name: "Packaging",
    2024: 40,
    2025: 35,
  },
]

// Table data for Suppliers Submitted Goals
export const supplierGoalstablecolumns = [
  {
    title: "Supplier Name",
    dataIndex: "supplierName",
    key: "supplier",
    align:"center"
  },
  {
    title:"Rank",
    dataIndex:"rank",
    key:"rank",
    align:"center"
  },
  {
    title: "Active Goal Count",
    dataIndex: "activeGoalCount",
    key: "activeGoalCount",
    align: "center",
  },
  {
    title: "Supplier Achieved percentage",
    dataIndex: "targetAchievedPercentage",
    key: "achievedPercentage",
    align: "center",
  },
  {
    title: "Goals YOY",
    dataIndex: "yoy",
    key: "yoy",
    align: "center",
    render: (yoy) => (
      <div className="flex items-center justify-center">
        <span>{yoy}</span>
        {Number.parseFloat(yoy) > 0 ? (
          <img src={upGreenArrow || "/placeholder.svg"} alt="icon" className="w-2 h-2 ml-2" />
        ) : (
          <img src={downRedArrow || "/placeholder.svg"} alt="icon" className="w-2 h-2 ml-2" />
        )}
      </div>
    ),
  },
]

export const CDPReportTableColumns=[
  {
   title:"Company Name",
   dataIndex:"companyName",
   key:"companyName",
   align:"center"
  },
  {
    title:"Rank",
    dataIndex:"rank",
    key:"rank",
    align:"center"
  },
  {
    title:"Total Emissions",
    dataIndex:"totalCarbonEmission",
    key:"totalCarbonEmission",
    align:"center"
  },
  {
    title:"Emissions Saved",
    dataIndex:"totalEmissionSaved",
    key:"totalEmissionSaved",
    align:"center"
  },
  {
    title:"Percentage Reduction",
    dataIndex:"emissionReducedPercentage",
    key:"emissionReducedPercentage",
    align:"center"
  }
]

export const supplierGoalstabledata = [
  {
    key: "1",
    supplier: "Company1",
    totalSuppliers: 67,
    activeGoalCount: 12,
    achievedPercentage: "8%",
    yoy: "7",
  },
  {
    key: "2",
    supplier: "Company2",
    totalSuppliers: 30,
    activeGoalCount: 18,
    achievedPercentage: "10%",
    yoy: "9",
  },
  {
    key: "3",
    supplier: "Company3",
    totalSuppliers: 16,
    activeGoalCount: 14,
    achievedPercentage: "10%",
    yoy: "11",
  },
  {
    key: "4",
    supplier: "Company4",
    totalSuppliers: 12,
    activeGoalCount: 8,
    achievedPercentage: "21%",
    yoy: "6",
  },
  {
    key: "5",
    supplier: "Company5",
    totalSuppliers: 10,
    activeGoalCount: 10,
    achievedPercentage: "25%",
    yoy: "5",
  },
]

// Chart titles
export const CHART_TITLES = {
  ENERGY_CONSUMPTION: "Energy Consumption Reduction",
  WASTE_REDUCTION: "Waste Reduction",
  PACKAGING_REDUCTION: "Packaging Reduction",
}

